import { Injectable } from '@angular/core';

import {
  HttpClient,
  HttpParams,
  HttpResponse
} from '@angular/common/http';
import {
  Observable,
  Subject
} from 'rxjs';
import { getHttpParams } from '@iv/shared/utils';

@Injectable()
export class WorkspaceService {

  private refreshButtonClick = new Subject<any>();

  constructor(private http: HttpClient) { }

  getInstrumentInfo(args: any): Observable<HttpResponse<any>> {
    return this.http.get(
      '/lookup/stockInformation', {observe: 'response', params: getHttpParams(args)}
    );
  }

  public getFutureInfo(args: any): Observable<HttpResponse<any>> {
    return this.http.get(
      '/futures-summary-line/futuresInformation', {observe: 'response', params: getHttpParams(args)}
    );
  }

  public getFutureExpirations(underlyingId): Observable<HttpResponse<string[]>> {
    const params: HttpParams = new HttpParams({
      fromObject: {
        underlyingId
      }
    });
    return this.http.get<string[]>('/futures-summary-line/expirations', {observe: 'response', params});
  }

  getColumns(hasOptions, region, tabType: string): Observable<any> {
    let url = tabType === 'instrument' ? '/iv-live/assets/summary_line_columns' : '/iv-live/assets/futures_summary_line_columns';
    if (!hasOptions && tabType === 'instrument') {
      url += '_no_options';
    } else if (region === 1 && tabType === 'instrument') {
      url += '_1';
    }
    return this.http.get(`${url}.json?version=5`);
  }

  sendRefreshButtonClick(event) {
    this.refreshButtonClick.next(event);
  }

  getRefreshButtonClicked(): Observable<any> {
    return this.refreshButtonClick.asObservable();
  }
}
